/* eslint-disable consistent-return */
import { loaderService } from 'src/services/loaderService'
import { apileads } from '../enviroment/apileads'

const getLeads = async (dateInit, dateEnd) => {
  const body = {
    fecha_inicial: dateInit,
    fecha_final: dateEnd,
  }

  // console.log("body ", body);

  loaderService.show()

  const response = await apileads.post('/v1/leadsbyfecha', body)
  // console.log(response)
  try {
    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    return false
  }
}

// Gestion de leads paginada + filtrada del lado servidor.
// params: { fecha_inicial, fecha_final, page, pageSize, busqueda, marca, ciudad,
//           departamento, vehiculo, integrado_impulsa, testdrive }
// devuelve { success, data, total, total_filtrado, integrados, no_integrados, page, pageSize }
const getLeadsPaginado = async (params) => {
  loaderService.show()
  try {
    const response = await apileads.post('/v1/leadsbyfecha-paginado', params)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    console.error('getLeadsPaginado', error)
  } finally {
    loaderService.hide()
  }
}

// Trae SOLO los ids de todos los leads filtrados (sin paginar) para "seleccionar todo"
// cross-page. Mismos filtros que getLeadsPaginado. Devuelve { success, ids, total }.
const getLeadsIds = async (params) => {
  loaderService.show()
  try {
    const response = await apileads.post('/v1/leadsbyfecha-ids', params)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    console.error('getLeadsIds', error)
  } finally {
    loaderService.hide()
  }
}

const getLeadById = async (id) => {
  const idFormat = id
  const body = {
    id: idFormat.trim(),
  }

  console.log('body', body)
  const response = await apileads.post('/v1/leadsbyid', body)
  // console.log(response)
  try {
    if (response.status === 200) {
      loaderService.hide()
      return response.data
    }
  } catch (error) {
    loaderService.hide()
    return false
  }
}

const putLeads = async (params) => {
  const body = {
    id: params,
  }
  loaderService.show()

  // El await va DENTRO del try: si el backend responde 500 (o la peticion expira) axios lanza,
  // y con el await afuera el error escapaba sin ejecutar loaderService.hide(), dejando el loader
  // girando para siempre sin avisarle al usuario que la reintegracion habia fallado.
  try {
    const response = await apileads.put('/v1/leads', body)
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    console.error(error, 'Error al Postear')
    return false
  } finally {
    loaderService.hide()
  }
}

export { getLeads, getLeadsPaginado, getLeadsIds, putLeads, getLeadById }
